
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M567.2 142.4l-37.56-37.56c-5.859-5.859-13.54-8.789-21.23-8.789s-15.37 2.93-21.23 8.789L275.4 316.6a10.015 10.015 0 00-2.738 5.109L256.1 400h-12.8l-24-24c-6.031-6.062-16.59-6.062-22.62 0l-17.89 17.91-28.02-67.25c-5-12-24.56-12-29.56 0L90.67 400H72c-4.42 0-8 3.6-8 8s3.58 8 8 8h24a7.997 7.997 0 007.391-4.938L136 332.8l32.61 78.28c2.191 5.25 8.975 6.625 13.05 2.594L208 387.3l26.34 26.34c1.46 1.56 3.56 2.36 5.66 2.36 0 0 27.27-.066 27.95-.203l82.32-16.46a10.034 10.034 0 005.111-2.734l211.8-211.8C578.9 173.1 578.9 154.1 567.2 142.4zM345.4 384l-71.74 14.45 14.36-71.82 157.7-157.7 57.38 57.38L345.4 384zm210.5-210.5l-41.55 41.54-57.38-57.38 41.54-41.54c5.471-5.469 14.35-5.477 19.83 0l37.56 37.56c5.5 5.42 5.5 14.32 0 19.82zM376 432a8 8 0 00-8 8v8c0 26.51-21.49 48-48 48H64c-26.51 0-48-21.49-48-48V64c0-26.51 21.49-48 48-48h144v120c0 22.09 17.91 40 40 40h133.3c1.5 0 2.7-1.2 2.7-2.7a32 32 0 00-9.375-22.63L233.4 9.367c-6-6-14.2-9.367-22.7-9.367H63.93C28.58 0 0 28.65 0 64l.006 384c0 35.34 28.58 64 63.93 64H320c35.35 0 64-28.66 64-64v-8c0-4.4-3.6-8-8-8zM224 22.63L361.4 160H248c-13.2 0-24-10.8-24-24V22.63z"}})])
          )
        }
      }
    